var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGlobe = function SvgGlobe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    fillRule: "evenodd",
    clipPath: "url(#globe_svg__a)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 2.25a6.75 6.75 0 1 0 0 13.5 6.75 6.75 0 0 0 0-13.5M.75 9a8.25 8.25 0 1 1 16.5 0A8.25 8.25 0 0 1 .75 9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.623 2.605c-.27-.286-.481-.355-.623-.355s-.352.069-.623.355c-.272.287-.551.744-.802 1.37C7.075 5.224 6.75 7 6.75 9s.326 3.776.825 5.025c.25.626.53 1.083.802 1.37.27.286.481.355.623.355s.352-.069.623-.355c.272-.287.551-.744.802-1.37.5-1.249.825-3.025.825-5.025s-.326-3.776-.825-5.025c-.25-.626-.53-1.083-.802-1.37m2.195.813c.586 1.466.932 3.44.932 5.582s-.346 4.116-.932 5.582c-.293.73-.66 1.373-1.105 1.844-.448.473-1.026.824-1.713.824s-1.265-.351-1.713-.824c-.445-.471-.812-1.113-1.105-1.844-.586-1.466-.932-3.44-.932-5.582s.346-4.116.932-5.582c.293-.73.66-1.373 1.105-1.844C7.735 1.101 8.313.75 9 .75s1.265.351 1.713.824c.445.471.812 1.113 1.105 1.844"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.75 9a.75.75 0 0 1 .75-.75h15a.75.75 0 0 1 0 1.5h-15A.75.75 0 0 1 .75 9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "globe_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h18v18H0z"
  })))));
};
export default SvgGlobe;